const ProductGrid = () => {
  const products = [
    {
      id: "ai-traffic-management",
      title: "AI Traffic Management (ATMS)",
      desc: "Automate traffic monitoring, predict congestion, and identify violations using ANPR, speed detection, and real-time video analytics.",
      image: "/images/trafficimg1.png",
      features: ["ANPR & Speed", "Incident Alerts", "ADAS Integration"]
    },
    {
      id: "people-crowd-management",
      title: "People & Crowd Management",
      desc: "Estimate crowd density, track real-time footfall, and analyze human movement patterns for optimized occupancy and safety.",
      image: "/images/trafficimg2.jpeg",
      features: ["Crowd Estimation", "Pose Detection", "Movement Flow"]
    },
    {
      id: "safety-compliance-monitoring",
      title: "Safety & Compliance Monitoring",
      desc: "Ensure workplace compliance through real-time PPE detection, dynamic restricted-zone alerts, and unattended object tracking.",
      image: "/images/trafficimg3.jpeg",
      features: ["PPE Detection", "Restricted Zones", "Unattended Objects"]
    }
  ];

  return (
    // 1. Manage top padding here (`pt-24`) and overall container height/background
    <div className="pt-24 min-h-screen bg-white relative selection:bg-[#952877]/10 selection:text-[#952877]">
      
      {/* --- HEADER --- */}
      {/* 2. Manage header top/bottom padding here (`py-10`) */}
      <section className="py-10 text-center relative z-10 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-black text-[#17091a] mb-6 tracking-tighter leading-[1.1]">
            Our Core <span className="bg-gradient-to-r from-[#952877] via-[#592aa7] to-[#17091a] bg-clip-text text-transparent px-1">Modules</span>
          </h1>
          <p className="text-gray-500 text-lg font-medium max-w-2xl mx-auto">
            Explore our comprehensive AI-powered video analytics platforms for traffic, crowds, and safety monitoring.
          </p>
        </div>
      </section>

      {/* --- 3-COLUMN HORIZONTAL GRID SECTION --- */}
      {/* 3. Manage bottom spacing below the cards section here (`pb-10`) */}
      <section className="pb-10 relative z-10 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3  gap-8">
          {products.map((product, idx) => (
            <div
              key={product.id}
              // NOTE: If you ever want it clickable again, add `onClick={() => navigate(...)}` and `cursor-pointer` here.
              className="group flex flex-col justify-between p-8 bg-[#e9e9e9] border border-black rounded-[2.5rem] hover:bg-white hover:shadow-[0_30px_80px_-20px_rgba(23,9,26,0.08)] hover:-translate-y-2 transition-all duration-700 overflow-hidden relative"
            >
              <div>
                {/* Image Container */}
                {/* 4. Manage space below the image here (`mb-8`) */}
                <div className="w-full aspect-[4/3] overflow-hidden rounded-[2rem] relative shadow-lg mb-6">
                  <img 
                    src={product.image} 
                    alt={product.title} 
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000 grayscale-[0.2] group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#17091a]/30 to-transparent"></div>
                </div>

                {/* Content */}
                {/* 5. Manage space below title (`mb-4`) and paragraph (`mb-6`) here */}
                <h3 className="text-2xl font-black text-[#17091a] mb-4 tracking-tight group-hover:text-[#952877] transition-colors duration-500">
                  {product.title}
                </h3>
                <p className="text-gray-500 text-sm font-medium leading-relaxed mb-6">
                  {product.desc}
                </p>

                {/* Features Tag Cloud */}
                {/* 6. Manage space below tag cloud here (`mb-8`) */}
                <div className="flex flex-wrap gap-2 mb-8">
                  {product.features.map((f, i) => (
                    <span key={i} className="px-3 py-1.5 rounded-lg bg-white border border-gray-100 text-[12px] font-black uppercase tracking-widest text-[#17091a]">
                      {f}
                    </span>
                  ))}
                </div>
              </div>

            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default ProductGrid;